(() => {
  if (customElements.get('kr-diy-welcome')) return;
  customElements.define('kr-diy-welcome', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog?.showModal || this.dataset.designMode === 'true') return;
      this.listeners = new AbortController();
      const options = {signal:this.listeners.signal};
      this.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), options));
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      const key = this.dataset.cooldownKey;
      let shown = 0;
      try { shown = Number(localStorage.getItem(key)||0); } catch (_) {}
      const forced = new URLSearchParams(location.search).get('welcome') === 'site';
      if (!forced && shown && Date.now()-shown < 7*24*60*60*1000) return;
      this.timer = setTimeout(() => {
        if (!this.isConnected || document.hidden || document.querySelector('dialog[open],.shopify-challenge__container') || document.fullscreenElement) return;
        this.dialog.showModal();
        try { localStorage.setItem(key,String(Date.now())); } catch (_) {}
        this.dialog.querySelector('.kr-diy-welcome__primary')?.focus({preventScroll:true});
      }, forced ? 650 : 10000);
    }
    disconnectedCallback() { clearTimeout(this.timer);this.listeners?.abort();if(this.dialog?.open)this.dialog.close(); }
  });
})();
